module.exports = __webpack_public_path__ + "img/青黛.2bb6820d.jpg";